import { makeStyles } from "@mui/styles";

const ConnectionFormStyles = makeStyles((theme) => ({
  hipaaExpander: {
    paddingLeft: "33px"
  }
}));
export default ConnectionFormStyles;
